import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext } from "react";
import { type GuestsInputType, type PaymentState, type ValidityState } from "src/Modules/Hotels/constants";
import { Hotel, HotelRoom, RateConditionRoom } from "src/store/apis/Hotels";
import { SearchFormInputs } from "src/Modules/Hotels/constants/SearchPage";
import usePayment from "../Steps/Payment/hooks/usePayment";


type HotelDynamicContextType = {
  validityState: [ValidityState, Dispatch<SetStateAction<ValidityState>>];
  guestsState: [GuestsInputType, Dispatch<SetStateAction<GuestsInputType>>];
  primaryGuestKeyState: [string | null, Dispatch<SetStateAction<string | null>>];
  policiesAcceptedState: [boolean, Dispatch<SetStateAction<boolean>>];
  hotel: Hotel;
  selectedRoom: HotelRoom | null;
  searchObject: SearchFormInputs;
  numberOfNights: number;
  pointsFactor: number;
  sessionId: string;
  rateConditions: string[];
  rateConditionRoom: RateConditionRoom | null;
  isRateConditionsFetching: boolean;
  payment: ReturnType<typeof usePayment>;
  
};

const HotelDynamicDetailsContext = createContext<HotelDynamicContextType | null>(null);

const HotelDynamicDetailsProvider: FC<{ children: ReactNode; value: HotelDynamicContextType }> = ({ children, value }) => {
  return <HotelDynamicDetailsContext.Provider value={value}>{children}</HotelDynamicDetailsContext.Provider>;
};

const useHotelDynamicDetails = () => {
  const context = useContext(HotelDynamicDetailsContext);
  if (!context) throw new Error("Illegal Usage of context");
  return context;
};

export { useHotelDynamicDetails, HotelDynamicDetailsProvider };
export { StepButtonsPortalProvider, useStepButtonsPortal } from "./StepButtonsPortal";
